import CirclesPurpleIcon from '@src/assets/icons/circles-purple.svg';
import LogoIcon from '@src/assets/icons/logo-icon.svg';
import { Themed } from '@theme-ui/mdx';
import { StaticImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import { Box, Container, Flex } from 'theme-ui';
import FeedbackCard from './feedbackCard';

const feedbackSection = ({ title, feedback }) => {
  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      {feedback && feedback.length > 0 && (
        <Box className="relative">
          <Box
            bg="primaryPaleBg"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: '-1',
            }}
          ></Box>
          <CirclesPurpleIcon className="circle-bottom-left circle-orange" />

          <Container px={4} py={6} sx={{ position: 'relative', zIndex: '1' }}>
            <Themed.h2>{title}</Themed.h2>

            <Flex sx={{ position: 'relative' }}>
              <Box
                sx={{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'end',
                  '.slick-arrow': {
                    bottom: '-90px',
                  },
                }}
              >
                <Box className="home-page-feedback" pt={6}>
                  <Slider {...sliderSettings}>
                    {feedback.map((item) => (
                      <Box
                        sx={{
                          margin: '0 10px 55px',
                          maxWidth: '580px',
                        }}
                        key={item.id}
                      >
                        <FeedbackCard feedback={item} quoteColor="#fff8e0" />
                      </Box>
                    ))}
                  </Slider>
                </Box>
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  right: '0',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: '-1',
                  borderRadius: '90px',
                  overflow: 'hidden',
                  display: ['none', 'none', 'none', 'block'],
                  maxHeight: '100%',
                }}
              >
                <StaticImage
                  quality={100}
                  src="../assets/teenage-girl-with-dreadlocks.png"
                  alt=""
                />
              </Box>

              <Box
                sx={{
                  position: 'relative',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'block',
                  zIndex: '-1',
                  borderRadius: '90px',
                  overflow: 'hidden',
                  width: 'fit-content',
                  maxHeight: '100%',
                }}
              >
                <StaticImage
                  quality={100}
                  src="../assets/close-up-portrait-pleased-young-guy-dressed-maroon-casual-t-shirt-looking-smiling-camera-expresses-happyness-model-posing-isolated-yellow-people-youth.png"
                  alt=""
                />
                <LogoIcon
                  sx={{
                    color: 'white',
                    width: '70px',
                    height: '80px',
                    position: 'absolute',
                    top: '45px',
                    right: '45px',
                  }}
                />
              </Box>
            </Flex>
          </Container>
        </Box>
      )}
    </>
  );
};

export default feedbackSection;

feedbackSection.propTypes = {
  title: PropTypes.string.isRequired,
  feedback: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      author: PropTypes.string,
      avatar: PropTypes.string,
      text: PropTypes.string,
      price: PropTypes.string,
      rating: PropTypes.string,
      ratingCount: PropTypes.string,
    })
  ).isRequired,
};
